import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Row } from "shards-react";
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ViewIcon from '@material-ui/icons/Visibility';
import Tooltip from '@material-ui/core/Tooltip';
import ValetBudgetComponent from './ValetBudget';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class Valet extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {saving: false, users:[],valet:{is_standard: true, costs:[{}], budgets:[{}], valet_budget:{budget:{}}, work_order:{user_id:''},vehicle_movement:{routes:[{}]}},transport_means:[],snackbar:{open:false}, loading: true, client_routes:[]}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.id
    	this.getUsers()
    	await this.getValet(work_order_id)
    	await this.getClientRouteCost(this.props.client_id);

    	this.setState({loading: false})
    }

    getUsers = () => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.work_order().users(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({users: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    
    }

   	async getValet(id){
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.valet().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var vehicle_movement = res.data.vehicle_movements[0]
	      		var costs = res.data.costs
	      		var valet = res.data
	      		valet.costs = costs
				valet.valet_budget = {}
				if (res.data.approved_budget.budget){
					valet.valet_budget.budget = res.data.approved_budget.budget
				} else {
					valet.valet_budget.budget = {id:''}
				}
	      		valet.vehicle_movement = vehicle_movement
	      		vehicle_movement.start_date = (vehicle_movement.start_date) ? vehicle_movement.start_date.replace(' ','T') : ''
	      		vehicle_movement.end_date = (vehicle_movement.end_date) ? vehicle_movement.end_date.replace(' ','T') : ''
				valet.work_order = {id: valet.work_order_id}
	      		this.setState({valet: valet, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    getClientRouteCost = async (client_id) => {
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.client_routes().get(client_id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({client_routes: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    
    }


    handleChange = (e) =>{
    	var valet = this.state.valet
    	var name = e.target.name
    	var value = e.target.value
    	if (['start_date','end_date','requirements','valet_type','has_waiting_time','has_middle_points','is_standard'].includes(name)){
    		if (['has_waiting_time','has_middle_points','is_standard'].includes(name)){
    			valet[name] = e.target.checked
    		} else if (['start_date', 'end_date','requirements'].includes(name)){
    			valet.vehicle_movement[name] = value
    		} else {
    			valet[name] = value
    		}
    	} else if (name === 'client_route_id'){
    		var client_route = this.state.client_routes.filter(client_route => client_route.id === parseInt(value))
    		valet.costs[0] = client_route[0]
    		valet.costs[0].is_cost = 1
    		valet.costs[0].is_real_cost = 0
    		valet.costs[0].is_margin = 0
    		valet.costs[0].is_budgeted = 0
    		valet.client_route_id = value

    	} else {
		    var element = name.split('.')
		    var key = element[0]
		    var id = element[1]
		    value = value.replace('$','').replace(',','')
		    if (['is_cost','is_real_cost','q_hr_extra','q_hr_normal','hour_value','fuel','tool','taxi','hotel','viatic','tickets','others','additionals','subtotal','hour_extra_value'].includes(key)){
		    	valet.costs[id][key] = value
		    } else {
		    	valet.vehicle_movement.routes[id][key] = value
		    }
    	}
    	this.setState({valet: valet})
    }

	handleBudgetChange = (name, value) =>{
		var valet = this.state.valet
		valet.valet_budget.budget[name] = value
		this.setState({valet: valet})
	}

	handlePercentage = (e) => {
		var valet = this.state.valet
		var value = e.target.value
		value = value.replace('%','')
		var cost = valet.costs.filter(cost => cost.is_cost === 1)[0]
		var margin = valet.costs.filter(cost => cost.is_margin === 1)[0]
		if (margin){
			value = value / 100;
			margin.others = cost.others * value 
			margin.additionals = cost.additionals * value 
			margin.q_hr_extra = cost.q_hr_extra * value 
			margin.q_hr_normal = cost.q_hr_normal * value
			margin.hour_extra_value = cost.hour_extra_value * value
			margin.hour_value = cost.hour_value * value
			margin.fuel = cost.fuel * value
			margin.tool = cost.tool * value
			margin.hotel = cost.hotel * value
			margin.viatic = cost.viatic * value
			margin.taxi = cost.taxi * value
			margin.tickets = cost.tickets * value 
			
			valet.costs[1] = margin
		}

		this.setState({valet: valet})
	}
	handleRestore = async (e) => {
	    const token = localStorage.getItem('userToken')
		let self = this
		return await axios
		  .get(api.valet().restore(this.state.valet.id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Costos reinicados con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})
				self.getValet(this.props.id)
				this.props.onUpdateWorkOrderState();
	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(errors.errors.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })		
	}


    handleSubmit = (e) => {
		this.setState({saving: true})
		e.preventDefault();
	    var formData = new FormData();
	    var url = api.valet().post();
	    formData.set("valet[work_order_id]", this.props.id);
	    formData.set("valet[has_waiting_time]", (this.state.valet.has_waiting_time) ? 1 : 0);
	    formData.set("valet[has_middle_points]", (this.state.valet.has_middle_points) ? 1 : 0);
	    formData.set("valet[is_standard]", (this.state.valet.is_standard) ? 1 : 0);
	    formData.set("valet[valet_type]", (this.state.valet.valet_type) ? this.state.valet.valet_type : '');
	    formData.set("valet[client_route_id]", (this.state.valet.client_route_id) ? this.state.valet.client_route_id : '')

	    formData.set("vehicle_movement[work_order_id]", this.props.id);
	    if (this.state.valet.vehicle_movement.id){
		    formData.set("vehicle_movement[id]", this.state.valet.vehicle_movement.id);
	    }

	    formData.set("vehicle_movement[start_date]", (this.state.valet.vehicle_movement.start_date) ? this.state.valet.vehicle_movement.start_date : '');
	    formData.set("vehicle_movement[end_date]", (this.state.valet.vehicle_movement.end_date) ? this.state.valet.vehicle_movement.end_date : '');
	    formData.set("vehicle_movement[description]", 'Movimiento hecha por OT Valet');
	    formData.set("vehicle_movement[requirements]", (this.state.valet.vehicle_movement.requirements) ? this.state.valet.vehicle_movement.requirements : '');
	    formData.set("vehicle_movement[transport_mean]", 'Valet');
	    //formData.set("vehicle_movement[total_cost]", (this.state.vehicle_movement.total_cost) ? this.state.vehicle_movement.total_cost : 0);

	    this.state.valet.vehicle_movement.routes.map((val,idx)=>{
		    formData.set("routes["+idx+"][origin_place]", (val.origin_place) ? val.origin_place : '');
		    formData.set("routes["+idx+"][destiny_place]", (val.destiny_place) ? val.destiny_place : '');
		    if (val.id){
			    formData.set("routes["+idx+"][id]", val.id);
		    }
	    })

		formData.set("valet_budget[user_id]", (this.state.valet.valet_budget.budget.user_id) ? this.state.valet.valet_budget.budget.user_id : '')
		formData.set("valet_budget[provider_id]", (this.state.valet.valet_budget.budget.provider_id) ? this.state.valet.valet_budget.budget.provider_id : '')
		if (this.state.valet.vehicle_movement && !this.state.valet.valet_budget.budget.user_id){
			formData.set("valet_budget[user_id]", (this.state.valet.vehicle_movement.routes) ? this.state.valet.vehicle_movement.routes[0].user_id : '')
		}
		
	    if (this.state.valet.id !== undefined) {
	    	url = api.valet().patch(this.props.id)
		    formData.set("valet[id]", this.state.valet.id);
		    formData.set("_method", 'PATCH');
	    }

	    /* Costs */
	    this.state.valet.costs.map((val,idx)=>{
	    	if (val.is_cost !== undefined && val.is_real_cost !== undefined && val.is_margin !== undefined && val.is_budgeted !== undefined){
		    	if (val.id !== undefined){
				    formData.set("costs["+idx+"][id]", val.id);
		    	}

			    formData.set("costs["+idx+"][is_margin]", val.is_margin);
			    formData.set("costs["+idx+"][is_cost]", val.is_cost);
			    formData.set("costs["+idx+"][is_real_cost]", val.is_real_cost);
			    formData.set("costs["+idx+"][hour_value]", (val.hour_value) ? val.hour_value : 0);
			    formData.set("costs["+idx+"][hour_extra_value]", (val.hour_extra_value) ? val.hour_extra_value : 0);
			    formData.set("costs["+idx+"][q_hr_normal]", (val.q_hr_normal) ? val.q_hr_normal : 0);
			    formData.set("costs["+idx+"][q_hr_extra]", (val.q_hr_extra) ? val.q_hr_extra : 0);
			    formData.set("costs["+idx+"][hotel]", (val.hotel) ? val.hotel : 0);
			    formData.set("costs["+idx+"][fuel]", (val.fuel) ? val.fuel : 0);
			    formData.set("costs["+idx+"][viatic]", (val.viatic) ? val.viatic : 0);
			    formData.set("costs["+idx+"][viatic]", (val.viatic) ? val.viatic : 0);
			    formData.set("costs["+idx+"][others]", (val.others) ? val.others : 0);
			    formData.set("costs["+idx+"][additionals]", (val.additionals) ? val.additionals : 0);
			    formData.set("costs["+idx+"][tickets]", (val.tickets) ? val.tickets : 0);
			    formData.set("costs["+idx+"][taxi]", (val.taxi) ? val.taxi : 0);
			    formData.set("costs["+idx+"][tool]", (val.tool) ? val.tool : 0);
		    		
	    	}
	    })

	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Valet cargado con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})
				self.getValet(this.props.id)
				self.setState({saving: false})
				this.props.onUpdateWorkOrderState();
	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(errors.errors.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
				self.setState({saving: false})

	    })
    }

    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }
	handleNewRoute = (e) => {
		e.preventDefault()
		var routes = this.state.valet.vehicle_movement.routes
		routes.push({origin_place:'', destiny_place:''})
		this.setState({routes: routes})
	}

	handleRemoveRoute = (e,id) => {
		e.preventDefault()
		var valet = this.state.valet
		valet.vehicle_movement.routes = valet.vehicle_movement.routes.filter((s, sidx) => id !== sidx);
		this.setState({valet: valet})
	}

	render() {
		var valet = this.state.valet
		var vehicle_movement = valet.vehicle_movement
		var costs = valet.costs
		var routes = vehicle_movement.routes
		var budgets = valet.budgets
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
				{(this.state.loading)
					?
					''
					:
					<React.Fragment>
	                    <Row className="ml-1 mt-1">
							<TextField
								id="start_date"
								value={vehicle_movement.start_date}
								onChange={this.handleChange}
								type="datetime-local"
								name="start_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha desde</Typography></InputAdornment>,
								}}
							/>		
							<TextField
								id="end_date"
								value={vehicle_movement.end_date}
								onChange={this.handleChange}
								type="datetime-local"
								name="end_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha hasta</Typography></InputAdornment>,
								}}
							/>		
					       <TextField
								id="valet_type"
								placeholder="Tipo de Valet"	
								name="valet_type"
								onChange={this.handleChange}
								value={valet.valet_type}
								select
								margin="normal"
								className="mr-2 mt-0"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
					          	InputProps={{
						            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Tipo de Valet</Typography></InputAdornment>,
						            style:{fontSize: '0.75rem'}
									}}
					        >
					            <MenuItem key={"Por tramo"} value={"Por tramo"} className={classes.menu}>
					              Por costo predefinido
					            </MenuItem>
					            <MenuItem key={"Por presupuesto"} value={"Por presupuesto"} className={classes.menu}>
					              Por presupuesto
					            </MenuItem>
					        </TextField>
					        {(valet.valet_type === 'Por tramo')
					     	?
					     		<React.Fragment>
					     			{(valet.id !== undefined)
					     			?
					     				''
					     			:
										<TextField
											id="client_route_id"
											name="client_route_id"
											value={valet.client_route_id}
											onChange={this.handleChange}
											select
											margin="normal"
											className="m-0 p-0 mr-2"
											InputLabelProps={{
												shrink: true
											}}
											inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
											InputProps={{
											    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Tramos</Typography></InputAdornment>,
										        style:{fontSize: '0.75rem'}
											}}
										>
										  {this.state.client_routes.map((option) => (
										    <MenuItem key={option.id} value={option.id} className={classes.menu} style={{fontSize: '0.75rem'}} disabled={option.disabled}>
										      {option.name} - ${option.cost} c/{option.up_to_km} km
										    </MenuItem>
										  ))}
										</TextField>
					     			}
									<Tooltip title="Ver tramos" aria-label="ver_ot"><ViewIcon className="mx-1" onClick={()=>window.open("/client_routes/" +this.props.client_id, "_blank")}/></Tooltip>
								</React.Fragment>

					     	:
					     		''
					     	}

							<TextField
								id="requirements"
								value={vehicle_movement.requirements}
								onChange={this.handleChange}
								type="text"
								name="requirements"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Requerimientos</Typography></InputAdornment>,
								}}
							/>		
							<FormControlLabel
								className="mr-2 mb-0"
								control={<Switch size="small" id="has_waiting_time" name="has_waiting_time" value={valet.has_waiting_time} checked={valet.has_waiting_time}  onChange={this.handleChange} />}
								label={<Typography variant="caption" >Tiempo de espera?</Typography>}
								labelPlacement="start"
							/>
							<FormControlLabel
								className="mr-2 mb-0"
								control={<Switch size="small" id="has_middle_points" name="has_middle_points" value={valet.has_middle_points} checked={valet.has_middle_points}  onChange={this.handleChange} />}
								label={<Typography variant="caption" >Puntos intermedios?</Typography>}
								labelPlacement="start"
							/>
							<FormControlLabel
								className="mr-2 mb-0"
								control={<Switch size="small" id="is_standard" name="is_standard" value={valet.is_standard} checked={valet.is_standard}  onChange={this.handleChange} />}
								label={<Typography variant="caption" >Es standard?</Typography>}
								labelPlacement="start"
							/>

						</Row>
						{(valet.id > 0 )
						?
							<ValetBudgetComponent work_order={valet.work_order} show_detail={false} handleBudgetChange={this.handleBudgetChange}  budget_id={this.state.valet.valet_budget.budget.id}/>
						:
							''
						}

	                    <Row className="ml-1 mt-1">
							<Typography variant="subtitle1">Puntos</Typography>
						</Row>
			            {(routes.map((val, idx)=>{
			            	return (
		                    <Row className="ml-1 mt-1">
								<TextField
			                        id={"origin_place."+idx}
									value={val.origin_place}
									onChange={this.handleChange}
									type="text"
			                        name={"origin_place."+idx}
									margin="normal"
									className="m-0 p-0 mr-2"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
									InputProps={{
									    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Origen</Typography></InputAdornment>,
									}}
								/>		
								<TextField
			                        id={"destiny_place."+idx}
									value={val.destiny_place}
									onChange={this.handleChange}
									type="text"
			                        name={"destiny_place."+idx}
									margin="normal"
									className="m-0 p-0 mr-2"
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
									InputProps={{
									    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Destino</Typography></InputAdornment>,
									}}
								/>
								{(this.state.valet.has_middle_points)
									?
										<React.Fragment>
											<IconButton size="small">
												<AddIcon onClick={(e)=> {this.handleNewRoute(e)}} />
											</IconButton>
											<IconButton size="small">
												<RemoveIcon  onClick={(e) => {this.handleRemoveRoute(e,idx)}} />
											</IconButton>
										</React.Fragment>
									:
									''
								}	
							</Row>	
		                	)
			            }))}

						{(valet.id > 0)
						?
							<React.Fragment>
								<Table size="small" style={{width: 'auto'}}>
									<TableHead>
										<TableRow>
											<TableCell><Typography variant="subtitle1">Detalle</Typography></TableCell>
											{(costs.map((val,idx)=>{
												return (
													<TableCell className="m-0 p-0" style={{fontWeight: '550'}} >{val.label}
													{
														(val.is_margin === 1 && !val.disabled)
															?
																<NumberFormat 
																	id={"percentage"}
																	name={"percentage"}
																	value={valet.percentage}
																	disabled={val.disabled}
																	onChange={this.handlePercentage}
																	className="ml-2 mt-0"
																	InputProps={{style: {width: 70,fontSize: '0.75rem', borderBottom: '0px', padding: 0}}}
																	decimalSeparator='.'
															thousandSeparator=','
																	thousandSeparator=','
																	prefix={'%'}
																	customInput={TextField}  
																	InputLabelProps={{
																	shrink: true,
																	}}
																	isAllowed={(values) => {
																		let { floatValue } = values;
																		floatValue = (floatValue !== undefined) ? floatValue : 0
																		return floatValue >= 0 && floatValue <= 100;
																	}}            

																/> 
															: 
																''
													}
													</TableCell>
												)
											}))}
										</TableRow>
									</TableHead>
									<TableBody>
										<TableCell component="th" scope="row">
											<TableRow>
												<TableCell>
													<TextField
														id="Valor_HR"
														value="Valor HR"
														disabled={true}
														type="text"
														name="Valor_HR"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Valor_HR Extra"
														value="Valor HR Extra"
														disabled={true}
														type="text"
														name="Valor_HR"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Cant._hrs_normal"
														value="Cant. hrs normal"
														disabled={true}
														type="text"
														name="Valor_HR"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Cant_hrs_extra"
														value="Cant hrs extra"
														disabled={true}
														type="text"
														name="Cant_hrs_extra"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Combustible"
														value="Combustible"
														disabled={true}
														type="text"
														name="Combustible"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Hotel"
														value="Hotel"
														disabled={true}
														type="text"
														name="Hotel"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Peaje"
														value="Peaje"
														disabled={true}
														type="text"
														name="Peaje"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Taxi"
														value="Traslados (taxi, remis, otros)"
														disabled={true}
														type="text"
														name="Taxi"
														margin="normal"
														className="m-0 p-0"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Viaticos"
														value="Viaticos"
														disabled={true}
														type="text"
														name="Viaticos"
														margin="normal"
														className="m-0 p-0"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Pasajes"
														value="Pasajes"
														disabled={true}
														type="text"
														name="Pasajes"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0 mr-2"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Adicionales"
														value="Adicionales"
														disabled={true}
														type="text"
														name="Adicionales"
														margin="normal"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														className="m-0 p-0"
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Otros"
														value="Otros"
														disabled={true}
														type="text"
														name="Otros"
														margin="normal"
														className="m-0 p-0"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell>
													<TextField
														id="Subtotal"
														value="Subtotal"
														disabled={true}
														type="text"
														name="Subtotal"
														margin="normal"
														className="m-0 p-0"
														inputProps={{style:{minWidth: 70, fontSize: '0.75rem', borderBottom: '0px', padding:0}}}
														InputLabelProps={{
															shrink: true
														}}
													/>		
												</TableCell>
											</TableRow>
										</TableCell>
										{(costs.map((val,idx)=>{
											return (
											<React.Fragment>
												<TableCell className="p-0" style={{borderBottom: 'none'}}>
													<TableRow>
														<TableCell>
														<NumberFormat 
															id={"hour_value."+idx}
															name={"hour_value."+idx}
															value={val.hour_value}
															disabled={val.disabled}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem', borderBottom: '0px'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/> 
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell>
														<NumberFormat 
															id={"hour_extra_value."+idx}
															name={"hour_extra_value."+idx}
															value={val.hour_extra_value}
															disabled={val.disabled}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem', borderBottom: '0px'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell>
														<NumberFormat 
															id={"q_hr_normal."+idx}
															name={"q_hr_normal."+idx}
															value={val.q_hr_normal}
															disabled={val.disabled}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={''}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell>
														<NumberFormat 
															id={"q_hr_extra."+idx}
															name={"q_hr_extra."+idx}
															value={val.q_hr_extra}
															disabled={val.disabled}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															InputProps={{style: {width:70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={''}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
																let { floatValue } = values;
																floatValue = (floatValue !== undefined) ? floatValue : 0
																return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>										      										      
													<TableRow>
														<TableCell>
														<NumberFormat 
															id={"fuel."+idx}
															name={"fuel."+idx}
															value={val.fuel}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"hotel."+idx}
															name={"hotel."+idx}
															value={val.hotel}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															disabled={val.disabled}
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          

														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"tool."+idx}
															name={"tool."+idx}
															value={val.tool}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"taxi."+idx}
															name={"taxi."+idx}
															value={val.taxi}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"viatic."+idx}
															name={"viatic."+idx}
															value={val.viatic}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>

													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"tickets."+idx}
															name={"tickets."+idx}
															value={val.tickets}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"additionals."+idx}
															name={"additionals."+idx}
															value={val.additionals}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"others."+idx}
															name={"others."+idx}
															value={val.others}
															onChange={this.handleChange}
															disabled={val.disabled}
															className="mr-2 mt-0"
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell style={{fontWeight: '550'}} >
														<NumberFormat 
															id={"subtotal."+idx}
															name={"subtotal."+idx}
															value={val.subtotal}
															onChange={this.handleChange}
															className="mr-2 mt-0"
															disabled={val.disabled}
															InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
															decimalSeparator='.'
															thousandSeparator=','
															prefix={'$'}
															customInput={TextField}  
															InputLabelProps={{
															shrink: true,
															}}
															inputProps={{
																style:{padding: 0}
															}}
															isAllowed={(values) => {
															let { floatValue } = values;
															floatValue = (floatValue !== undefined) ? floatValue : 0
															return floatValue >= 0 && floatValue < 99999999;
															}}            

															/>                          
														</TableCell>
													</TableRow>

												</TableCell>
											</React.Fragment>
											)
										}))}
									</TableBody>
								</Table>

							</React.Fragment>
						
						:
							''
						}














{/*			            {(costs.map((val, idx)=>{
			            	return (
			            		<React.Fragment>
			                    <Row className="ml-1 mt-1">
									<Typography variant="subtitle2">{(val.is_cost) ? 'Costo Proyectado' : (val.is_real_cost) ? 'Gasto Real' : '' }</Typography>
								</Row>	
			                    <Row className="ml-1 mt-1">


			                        </Row>
			                        </React.Fragment>                     
			                	)
			            }))}


*/}
						<div className="row mt-2">
							<Button className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}} disabled={this.state.saving}>
								{(valet.id > 0)
								?
									'Guardar'
								:
									'Cargar'
								}
							</Button>
							{valet.id && 
								<Button className="mt-1 ml-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleRestore(e)}}>
									Reiniciar costos
								</Button>
						
							}

						</div>
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(Valet);

